<template>
  <div class="poster-list">
    <template v-if="list && list.length > 0">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col
            :sm="12"
            :md="6"
            v-for="(item, index) in list"
            :key="'act-' + index"
            class="w-20"
          >
          <div class="poster-list-one">
            <div class="poster-imgbox">
              <img v-if="item.backgroundImage" :src="item.backgroundImage">
              <img src="@/assets/img/empty.png" v-else />
              <canvas canvas-id="share" style="width:90%;height:50%" class="canvas"></canvas>
            </div>
            <div class="poster-btn">
              <div class="txt" @click="open(item)" style="color: #1890ff;" v-if="!item.isShow">开启</div>
              <div class="txt" @click="close(item)" style="color: #1890ff;" v-else>关闭</div>
              <div class="poster-btn-line"></div>
              <div class="txt" @click="edit(item)">编辑</div>
            </div>
          </div>
          </Col>
        </Row>

      </div>
    </template>
    <div v-else style="line-height:500px;text-align:center;">暂无数据</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-poster-list",
  props: {
    search: {
      type: String,
      default() {
        return "";
      }
    }
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  data() {
    return {
      list: [],
      show: false,
    }
  },
  methods: {
    ...mapActions({
      getSharePoster: "hostCommonModule/getSharePoster",
      editSharePoster: "hostCommonModule/editSharePoster",
    }),
    async init() {
      let list = await this.getSharePoster(this.exhibitionInfo.id);
      if (list && list.length > 0) {
        list.map(c => {
          c.posterInfo = JSON.parse(c.posterInfo);
        })
        this.list = list;
      }
      console.log(list)
    },
    async open(item) {
      let req = {
        Id: item.id,
        SetValues: {
          IsShow: true
        }
      }
      let bool = await this.editSharePoster(req);
      if (bool && bool.successed) {
        this.$Message.success(`保存成功`);
        this.init();
      } else {
        this.$Message.error(`保存失败，请重试`);
      }
    },
    async close(item) {
      let req = {
        Id: item.id,
        SetValues: {
          IsShow: false
        }
      }
      let bool = await this.editSharePoster(req);
      if (bool && bool.successed) {
        this.$Message.success(`保存成功`);
        this.init();
      } else {
        this.$Message.error(`保存失败，请重试`);
      }
    },
    async edit(item) {
      this.$router.push({
        path: '/host/index/common/common-poster-edit',
        query: {
          id: item.id
        }
      })
    },
    async delItem(item) {
    },
  },
  created() {
    this.init();
  }
}
</script>

<style lang="scss" scoped>
.poster-list {
  min-width: 1000px;
  padding: 30px 30px 100px 30px;
  &-one {
    background-color: #fff;
    margin-bottom: 20px;
    .poster-imgbox {
      width: 100%;
      height: 400px;
      position: relative;
      img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-height: 100%;
      }
      .canvas {
        position: absolute;
      }
    }
    .poster-btn {
      font-size: 14px;
      height: 48px;
      text-align: center;
      color: #808080;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .txt {
        width: 50%;
      }
      &-line {
        display: inline-block;
        width: 1px;
        height: 30px;
        background-color: #e8e8e8;
        padding-top: 18px;
      }
    }
  }
}
</style>
<style lang="scss">
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal{
      top: 0;
  }
}
</style>